<template>
  <v-text-field
    v-model="model"
    :disabled="disabled"
    prepend-icon="mdi-account-search"
    :label="label"
    single-line
    hide-details
  />
</template>

<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: 'Search'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      debounceId: null
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (val) {
        if (this.debounceId) {
          clearTimeout(this.debounceId)
        }
        this.debounceId = setTimeout(() => {
          this.$emit('input', val)
        }, 600)
      }
    }
  },
  beforeDestroy () {
    if (this.debounceId) {
      clearTimeout(this.debounceId)
    }
  }
})
</script>
